import classNames from 'classnames';
import BootstrapButtonGroup from 'react-bootstrap/ButtonGroup';

import Button, { ButtonSize, ButtonVariant } from 'components/common/Button/Button';
import ElementWithTooltip from 'components/common/ElementWithTooltip/ElementWithTooltip';

import './ToggleIconButtonGroup.scss';

type ToggleIconButtonProps = {
  active?: boolean;
  className?: string;
  icon: JSX.Element;
  onClick?: () => void;
  size: ButtonSize;
  testId?: string;
  tooltip?: string;
};

const ToggleIconButton = ({ className, icon, testId, tooltip, ...props }: ToggleIconButtonProps) => (
  <ElementWithTooltip placement="bottom" trigger={['hover', 'hover']} tooltip={tooltip}>
    <Button
      {...props}
      className={classNames('ToggleIconButtonGroup__ButtonIcon', className)}
      data-test-id={testId}
      variant={ButtonVariant.SECONDARY}
    >
      {icon}
    </Button>
  </ElementWithTooltip>
);

type ToggleIconButtonGroupProps = {
  buttons: Omit<ToggleIconButtonProps, 'size'>[];
  size?: ButtonSize;
};

/**
 * ToggleIconButtonGroup is a component for creating a group of related options expressed as buttons
 * with an icon and a tooltip, that behave like a toggle
 */
const ToggleIconButtonGroup = ({ buttons, size = 'sm' }: ToggleIconButtonGroupProps) => (
  <BootstrapButtonGroup className="ToggleIconButtonGroup">
    {buttons.map((button) => (
      <ToggleIconButton {...button} size={size} />
    ))}
  </BootstrapButtonGroup>
);

export default ToggleIconButtonGroup;
